// extracted by mini-css-extract-plugin
export default {"failed":"FailedIcon_failed__E8riY"};